import debounce from 'lodash/debounce'
import forEach from 'lodash/forEach'
import utils from '../utils/utils'

//
// Safety Datasheet
//

let initial = null

function setHeight(root) {
  let height = initial

  if (root) {
    forEach(root.querySelectorAll('.safety-datasheet__row--active .safety-datasheet__col'), (row) => {
      row.style.height = 'auto'
      if (height < row.scrollHeight) {
        height = row.scrollHeight
      }
    })

    root.style.height = `${height}px`
  } else {
    document.querySelector('.safety-datasheet').style.height = `${initial}px`
  }
}

function hideAll(rows) {
  forEach(rows, (row) => {
    utils.toggleClass(row, 'safety-datasheet__row--active', false)
  })
}

//
// Initialize
//

document.addEventListener('DOMContentLoaded', () => {
  const datasheetCol = document.querySelectorAll('.safety-datasheet__col')

  if (!(datasheetCol && datasheetCol.length)) {
    return
  }

  initial = datasheetCol[1].scrollHeight

  forEach(document.querySelectorAll('.safety-datasheet'), (root) => {
    setHeight()

    forEach(root.querySelectorAll('.safety-datasheet__row'), (row) => {
      row.addEventListener('click', (event) => {
        const col = event.currentTarget.parentElement
        const rows = col.querySelectorAll('.safety-datasheet__row')
        const isClose = event.target.className.match(/safety-datasheet__title/g)

        event.stopPropagation()

        hideAll(rows)

        if (!isClose) {
          utils.toggleClass(row, 'safety-datasheet__row--active', true)
        }
        setHeight(root)
      })
    })
  })
})

window.addEventListener('resize', debounce(() => {
  forEach(document.querySelectorAll('.safety-datasheet'), (root) => {
    setHeight(root)
  })
}))
